export enum TransformationStatus {
  NOT_STARTED = 'Nicht gestartet',
  IN_PROGRESS = 'In Arbeit',
  COMPLETED = 'Abgeschlossen'
}
